import axios from '@/libs/api.request'

const userBaseUrl = '/api/v1/'

export const changePassword = (data) => {
  return axios.request({
    url: userBaseUrl + 'password/change/',
    data: data,
    method: 'post'
  })
}

export const getHomeConfig = (params) => {
  return axios.request({
    url: userBaseUrl + 'home_config/',
    params: params,
    method: 'get'
  })
}

export const postHomeConfig = (data) => {
  return axios.request({
    url: userBaseUrl + 'home_config/',
    data: data,
    method: 'post'
  })
}

export const updateHomeConfig = (data) => {
  return axios.request({
    url: userBaseUrl + 'update_home_config/',
    data: data,
    method: 'post'
  })
}
